import "./contact-tab.scss";

import * as React from "react";

import {cst, cstAssign} from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Types}          from "@Common/types";

import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";

import {makeFieldFactory, makeInputFactory} from "../common/tab-fields";

import {ContactFormState, FIELD_NAMES} from "./contact-form-state";
import {equalDeep, filterKeys} from "@Common/utils/objects";

type FormModel          = Types.Xpresso.Account.Admin.OfficeManagement.ManagementModal.Contact.FormModel;
type DisplayFieldsModel = Pick<FormModel, Extract<keyof FormModel, `branchDisplay${string}`>>;

const FIELD_LABELS:{[key in keyof FormModel]-?: string} = {
    allowFeedUpdate : "Allow Feed to Update Office",
    branchDisplay1  : "Line 1",
    branchDisplay2  : "Line 2",
    branchDisplay3  : "Line 3",
    branchDisplay4  : "Line 4",
    branchDisplay5  : "Line 5",
    branchDisplay6  : "Line 6",
}

export const ContactTab = ({
    branch,
    disabled,
    hasUnsavedChangesStatic : {set: setHasUnsavedChanges},
    onSave                  : emitSave,
    resetCallbackSetter     : setResetCallback,
}:{
    branch                   : Types.Apis.Payloads.Next.Branch.GetById.Response,
    disabled                ?: boolean,
    hasUnsavedChangesStatic  : Types.Common.React.Static2.Static2Next<boolean>,
    onSave                   : (saving:Promise<void>) => void,
    resetCallbackSetter      : (reset:() => void) => void,
}): React.FunctionComponentElement<any> => cst<{
    apis         : Types.Apis.Loaders.XpressoLoadApis,
    formState    : Types.Xpresso.Account.Admin.OfficeManagement.ManagementModal.Contact.FormStateNext,
    fieldFactory : Types.Xpresso.Account.Admin.OfficeManagement.ManagementModal.TabFieldFactory<DisplayFieldsModel>,
}>(
    consumeContext("apis"),
    cstAssign("formState", ({}, next) => ContactFormState({branch, next})),
    ({formState}, next) => next(setResetCallback(() => formState.fromValue(branch))),
    cstAssign("fieldFactory", ({formState}, next) => next(makeFieldFactory({formState, inputFactory: makeInputFactory<DisplayFieldsModel>({formState, branch, setHasUnsavedChanges})}))),
    ({apis, formState, fieldFactory: makeField}) => (
        <div className="contact-tab-45f" xd-qa-type="card" xd-qa-name="Contact Info">
            <header xd-qa-type="label" xd-qa-name="Office Contact">Office Contact</header>
            <section>
                <div className="checkbox field-row">
                    <label xd-qa-type="label" xd-qa-name={FIELD_LABELS.allowFeedUpdate}>
                        {FIELD_LABELS.allowFeedUpdate}
                        <SliderCheckbox disabled={disabled} value={formState.value.allowFeedUpdate} xdQaName={"Allow Feed Slider " + formState.value.allowFeedUpdate || false}/>
                        <input
                            type="checkbox"
                            hidden
                            checked={formState.value.allowFeedUpdate || false}
                            disabled={disabled}
                            onChange={(e) => {
                                setHasUnsavedChanges(true);
                                formState.field("allowFeedUpdate").onChange(e.target.checked);
                            }}
                        />
                    </label>
                </div>
                {(FIELD_NAMES.filter(path => path !== "allowFeedUpdate")).map((path:keyof FormModel & `branchDisplay${string}`) => (
                    makeField({disabled, path, label: FIELD_LABELS[path], xdQaName: ""})
                ))}
            </section>

            <button
                disabled={disabled || equalDeep(formState.value, filterKeys(branch, (key) => key in formState.value)) || !formState.validate()}
                onClick={() => emitSave(apis.next.branch.updateBasicInfo({idBranch: branch.idBranch, ...formState.value}))}
                xd-qa-type="button"
                xd-qa-name="Save"
            >
                Save
            </button>
        </div>
    )
);

